import { render, staticRenderFns } from "./dataAssistant.vue?vue&type=template&id=dcfca27c"
import script from "./dataAssistant.vue?vue&type=script&lang=js"
export * from "./dataAssistant.vue?vue&type=script&lang=js"
import style0 from "./dataAssistant.vue?vue&type=style&index=0&id=dcfca27c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports